<template>
  <div class="mobile-search">
    <van-sticky>
      <div>
        <div class="class-main">
          <van-dropdown-menu active-color="#1989fa" :duration="0">
            <van-dropdown-item :title="value1" ref="item">
              <van-cell
                v-for="(item, index) in typeList"
                :key="index"
                center
                :title="item.name"
                @click="changeType(item.id, 'type', item.name)"
              >
              </van-cell>
            </van-dropdown-item>
            <van-dropdown-item :title="value2" ref="item2">
              <van-cell
                center
                title="全部"
                @click="changeType(0, 'category', '全部')"
              >
              </van-cell>
              <van-cell
                v-for="(item, index) in categoryList"
                :key="index"
                center
                :title="item.category_name"
                @click="changeType(item.id, 'category', item.category_name)"
              >
              </van-cell> </van-dropdown-item
            ><van-dropdown-item :title="value3" ref="item3">
              <van-cell
                center
                title="全部"
                @click="changeType(0, 'group', '全部')"
              >
              </van-cell>
              <van-cell
                v-for="(item, index) in groupList"
                :key="index"
                center
                :title="item.name"
                @click="changeType(item.id, 'group', item.name)"
              >
              </van-cell>
            </van-dropdown-item>
          </van-dropdown-menu>
        </div>
      </div>
    </van-sticky>

    <div class="ul-main">
      <van-list
        v-model="loading"
        :finished="finished"
        class="myList"
        id="myList"
        finished-text="没有更多了"
        @load="onLoad"
        v-if="list.length !== 0"
        :immediate-check="false"
      >
        <mobile-text-list :list="list" v-if="searchForm.type === 1" />
        <mobile-video-list :list="list" v-if="searchForm.type === 2" />
        <mobile-cartoon-list :list="list" v-if="searchForm.type === 4" />
        <mobile-audio-list :list="list" v-if="searchForm.type === 3" />
      </van-list>

      <div v-if="list.length === 0 && !loading" class="empty-text">
        <van-image
          height="auto"
          class="empty-img"
          :src="require('@/assets/empty.png')"
        />
        <div>这里空空如也～</div>
      </div>
      <div class="noPagination"></div>
      <!-- <van-loading
        v-if="list.length === 0 && loading"
        type="spinner"
        color="#1989fa"
        class="loading"
      /> -->
    </div>
  </div>
</template>
<script>
import MobileTextList from "./components/MobileTextList.vue";
import MobileVideoList from "./components/MobileVideoList.vue";
import MobileCartoonList from "./components/MobileCartoonList.vue";
import MobileAudioList from "./components/MobileAudioList.vue";
export default {
  components: {
    MobileTextList,
    MobileVideoList,
    MobileCartoonList,
    MobileAudioList,
  },
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      searchForm: {
        type: 2,
        category: "0",
        group: "0",
      },
      value1: "视频",
      value2: "全部",
      value3: "全部",
      typeList: [],
      categoryList: [],
      groupList: [],
      loading: false,
      finished: false,
      scroll: 0, //定义初始滚动高度
    };
  },
  watch: {
    "$store.getters.keyword": function () {
      this.currentPage = 1;
      this.list = [];
      this.finished = false;
      this.getList();
    },
  },
  methods: {
    onLoad() {
      if (this.list.length < this.total) {
        this.currentPage++;
        this.getList();
      } else {
        this.loading = false;
        this.finished = true;
      }
    },
    async getList() {
      this.loading = true;
      try {
        const { data } = await this.$axios.post(`Articleeducate/getList`, {
          title: this.$store.getters.keyword,
          type: this.searchForm.type,
          category: this.searchForm.category,
          crowd: this.searchForm.group,
          page: this.currentPage,
          size: this.pageSize,
        });
        data.list.forEach((item) => {
          this.list.push(item);
        });
        this.total = Number(data.total);
      } catch (error) {
        this.$toast(error?.errorMSg ?? "暂无数据");
      } finally {
        this.loading = false;
      }
    },
    changeType(id, name, title) {
      this.searchForm[name] = id;
      if (name === "type") {
        let sizes = [10, 10, 20, 10, 15];
        this.pageSize = sizes[id];
      }
      if (name === "type") {
        this.value1 = title;
        this.$refs.item.toggle();
      }
      if (name === "category") {
        this.value2 = title;
        this.$refs.item2.toggle();
      }
      if (name === "group") {
        this.value3 = title;
        this.$refs.item3.toggle();
      }

      // this.search();
      setTimeout(() => {
        this.currentPage = 1;
        this.list = [];
        this.finished = false;
        this.getList();
      }, 300);
    },
    async getType() {
      try {
        const { data } = await this.$axios.post(
          `Articleeducate/getCategory`,
          {}
        );
        this.typeList = data.type;
        this.categoryList = data.category;
        this.groupList = data.crowd;
      } catch (error) {
        this.$toast(error?.errorMSg ?? "暂无数据");
      }
    },
    handleScroll() {
      // 记录滚动的位置
      this.scroll = window.scrollY;
    },
  },
  created() {
    this.getType();
    this.getList();
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  activated() {
    if (this.scroll > 0) {
      // 滚动位置大于0  直接到指定位置
      window.scrollTo(0, this.scroll);
    }
    window.addEventListener("scroll", this.handleScroll);
  },
  //deactivated 页面退出时关闭事件 防止其他页面出现问题
  deactivated() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="scss" scoped>
::v-deep .mobile-main {
  background-color: #f2f5ff;
}

.mobile-search {
  padding-top: 20px;
}

.desktop-search {
  overflow: hidden;
}

.ul-main {
  width: 100%;
  height: auto;
  padding-bottom: 20px;
  margin-top: 0;
  background-color: white;
}

.class-main {
  width: 100%;
  height: auto;
  background: #fff;

  .type-main {
    display: inline-block;
    margin-top: 38px;
  }

  .class-li {
    display: inline-block;
    padding: 9px;
    margin-left: 5px;
    font-size: 20px;
    font-weight: 400;
    line-height: 20px;
    cursor: pointer;
  }

  .class-li-active {
    font-weight: 600;
    color: #fff;
    background: #0047ff;
    border-radius: 2px;
  }

  .category-main {
    display: inline-block;
    margin-top: 35px;

    .class-li {
      margin-bottom: 10px;
    }
  }

  .group-main {
    display: inline-block;
    margin-top: 40px;
  }

  .search-title {
    display: inline-block;
    width: 55px;
    padding: 9px;
    margin-left: 42px;
    font-size: 20px;
    font-weight: bold;
    line-height: 20px;
    color: #0047ff;
    vertical-align: top;
  }

  .items {
    display: inline-block;
    width: 100%;
    vertical-align: top;
  }
}

.fix-class-main {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}

.empty-text {
  width: 100%;
  padding: 170px 0;
  font-size: 14px;
  color: #b6daff;
  text-align: center;
}

.empty-img {
  width: 500px;
}

.noPagination {
  display: flex;
  width: 100%;
}

.loading {
  padding: 300px 0;
  margin: auto;
  text-align: center;
}
</style>
